module.exports = __webpack_public_path__ + "img/s1-3.8b705966.jpg";